<div [ngClass]="'bg--' + type" class="d-flex" style="border-radius: 2px;">
  <div class="text-center">
    <i style="padding-top: 21px; padding-left: 16px; padding-bottom: 16px;" [ngClass]="'text--' + type" class="fas {{icon}} fa-align-center col-1"></i>
  </div>
  <span class="custom-message">
    <span *ngIf="message">{{message}}</span>
    <div *ngIf="addContent">
      <ng-content></ng-content>
    </div>
  </span>
</div>
